import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Input, InputGroup, InputRightElement, IconButton, Icon } from "@chakra-ui/react";
import { Field } from "formik";
import { FormControl } from "formik-chakra-ui";
import { EyeIcon, EyeOffIcon } from "@inspire/ui/icons";
var PasswordInput = function(_param) {
    var name = _param.name, inputProps = _object_without_properties(_param, [
        "name"
    ]);
    var ref = useState(false), show = ref[0], setShow = ref[1];
    var handleClick = function() {
        return setShow(!show);
    };
    return /*#__PURE__*/ _jsxs(InputGroup, {
        children: [
            /*#__PURE__*/ _jsx(Input, _object_spread({
                type: show ? "text" : "password",
                id: name
            }, inputProps)),
            /*#__PURE__*/ _jsx(InputRightElement, {
                children: /*#__PURE__*/ _jsx(IconButton, {
                    h: "96%",
                    mr: "2px",
                    borderRadius: "0 5px 5px 0",
                    "aria-label": show ? "Visible" : "Cach\xe9",
                    variant: "ghost",
                    color: "#666",
                    icon: /*#__PURE__*/ _jsx(Icon, {
                        as: show ? EyeIcon : EyeOffIcon,
                        boxSize: 5
                    }),
                    onClick: handleClick
                })
            })
        ]
    });
};
export var PasswordInputField = function(input) {
    return /*#__PURE__*/ _jsx(Field, _object_spread({
        as: PasswordInput
    }, input));
};
export var PasswordControl = function(_param) /*#__PURE__*/ {
    var name = _param.name, label = _param.label, formControlProps = _object_without_properties(_param, [
        "name",
        "label"
    ]);
    return _jsx(FormControl, _object_spread_props(_object_spread({
        name: name,
        label: label
    }, formControlProps), {
        children: /*#__PURE__*/ _jsx(PasswordInputField, {
            name: name
        })
    }));
};
export default PasswordInput;
